'use client';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { MediaType } from '@repo/ui/src/types/image';
import Button, { ButtonVariant } from '@repo/ui/src/components/Button';
import { Anchor } from '@repo/ui/src/components/Anchor';
import useTranslation from "../../context/Translation/useTranslation";

export interface AuthorCardProps {
  name: string;
  avatar: MediaType;
  title: string;
  _meta?: {
    deliveryKey: string;
  };
}

const AuthorCard = ({ name, avatar, title, _meta }: AuthorCardProps) => {
  const { t } = useTranslation();
  const imgUrl = avatar && buildImageSrc(avatar, 370, 3, 3);
  return (
    <div>
      {imgUrl && (
        /* eslint-disable-next-line @next/next/no-img-element */
        <img
          alt={title}
          src={imgUrl}
          className="image tw-w-full tw-object-cover tw-object-center"
        />
      )}
      <div className="tw-bg-white tw-p-6" data-testId="text-container">
        {name && <h6 className="tra-text-web-heading-6 tw-pb-5 tw-text-left">{name}</h6>}
        {title && <hr className="tw-border-2 tw-w-6 tw-border-action-400" />}
        {title && <p className="tra-text-web-body-l tw-text-left tw-py-4">{title}</p>}
        {_meta?.deliveryKey && (
          <Button
            variant={ButtonVariant.knife}
            as={Anchor}
            link={_meta?.deliveryKey}
            className="tw-h-auto"
            size="small"
          >
            {t('generalContent.learnMore', undefined, {
              default: 'Learn More',
            })}
          </Button>
        )}
      </div>
    </div>
  );
};

export default AuthorCard;
